"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const components_1 = require("utils/components");
const classes = __importStar(require("./Breadcrumb.module.scss"));
const Breadcrumb = ({ configs }) => {
    return (react_1.default.createElement("nav", { "aria-label": "breadcrumb", className: classes["breadcrumb"] },
        react_1.default.createElement("ol", null, configs.map((item, index) => {
            const isLast = index === configs.length - 1;
            return (react_1.default.createElement("li", { key: index, className: (0, classnames_1.default)(classes["breadcrumb-item"], {
                    [classes["active"]]: isLast,
                }) },
                isLast ? (item.name) : item.path ? (react_1.default.createElement(components_1.Link, { to: item.path }, item.name)) : (item.name),
                !isLast && (react_1.default.createElement("span", null,
                    react_1.default.createElement("svg", { width: "7", height: "14", viewBox: "0 0 7 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        react_1.default.createElement("path", { d: "M1 13L6 6.84616L1 0.692311", stroke: "#3F3F46", "stroke-linecap": "round", "stroke-linejoin": "round" }))))));
        }))));
};
exports.default = Breadcrumb;
